/**
 * アコーディオン機能
 * .js--accordionクラスを持つ要素に対してアコーディオン機能を実装
 */
class Accordion {
    constructor() {
        this.accordions = document.querySelectorAll('.js--accordion');
        this.init();
    }

    init() {
        if (!this.accordions.length) return;

        this.accordions.forEach((accordion) => {
            const button = accordion.querySelector('.js--accordion__button');
            const content = accordion.querySelector('.js--accordion__content');

            if (!button || !content) return;

            // 初期状態を設定
            this.setInitialState(accordion, content);

            // クリックイベントを設定
            button.addEventListener('click', () => {
                this.toggle(accordion, content);
            });
        });
    }

    /**
     * 初期状態の設定
     * @param {HTMLElement} accordion - アコーディオン要素
     * @param {HTMLElement} content - コンテンツ要素
     */
    setInitialState(accordion, content) {
        // 初期状態は閉じた状態
        content.style.height = '0';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.3s ease';
    }

    /**
     * アコーディオンの開閉切り替え
     * @param {HTMLElement} accordion - アコーディオン要素
     * @param {HTMLElement} content - コンテンツ要素
     */
    toggle(accordion, content) {
        const isOpen = accordion.classList.contains('is-open');

        if (isOpen) {
            this.close(accordion, content);
        } else {
            this.open(accordion, content);
        }
    }

    /**
     * アコーディオンを開く
     * @param {HTMLElement} accordion - アコーディオン要素
     * @param {HTMLElement} content - コンテンツ要素
     */
    open(accordion, content) {
        accordion.classList.add('is-open');

        // 実際の高さを取得
        const height = content.scrollHeight;
        content.style.height = `${height}px`;

        // アニメーション終了後に高さをautoに設定（レスポンシブ対応）
        content.addEventListener('transitionend', function setAutoHeight() {
            if (accordion.classList.contains('is-open')) {
                content.style.height = 'auto';
            }
            content.removeEventListener('transitionend', setAutoHeight);
        });
    }

    /**
     * アコーディオンを閉じる
     * @param {HTMLElement} accordion - アコーディオン要素
     * @param {HTMLElement} content - コンテンツ要素
     */
    close(accordion, content) {
        // アニメーションのために一度高さを固定値に戻す
        const height = content.scrollHeight;
        content.style.height = `${height}px`;

        // リフローを強制
        content.offsetHeight;

        // 高さを0に設定してアニメーション
        content.style.height = '0';

        // アニメーション終了後にクラスを削除
        content.addEventListener('transitionend', function removeClass() {
            accordion.classList.remove('is-open');
            content.removeEventListener('transitionend', removeClass);
        });
    }
}

// DOMの読み込み完了後に初期化
document.addEventListener('DOMContentLoaded', () => {
    new Accordion();
});